import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import EventDetails from '../View/EventDetails'
import Grid from '@material-ui/core/Grid'
import {defaultGridSettings} from '../../../../js/settings/grid'
import CanidateDetails from './AdminConnectedEventsDetails/CanidatesDetails'
import RequesterDetails from '../View/RequesterDetails'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles';
import AltCanidateSelect from './AdminConnectedEventsDetails/AltCanidateSelect'
import AltCanidateDetails from './AdminConnectedEventsDetails/AltCanidateDetails'
import { fetchUserProfile } from '../../../../firebase/database/handleUsers'
//import { handleReConnectedEvent } from '../../../../actions/adminCanidates'
import Notification from '../../../../Container/PopUps/Notification'
//import moment from 'moment'
//import { newCanidateMessage } from '../../../../js/settings/text'
import Badge from '@material-ui/core/Badge'
const styles = theme => ({
    confirmButton: {
        marginBottom: theme.spacing.unit

    },
    selecteButton: {

    }
})
class AdminConnectedEventDetails extends Component {
    constructor () {
        super()
        this.state = {
            toggleAltCanidateSelect: false,
            toggleAltCanidateDetails: false,
            altCanidateDetails: null,
            notificationVisable: false,
            canidate: null,
            newCanidateMessage: null,
        }
    }
    
   
  
    notification = {
        headline: 'Neuer Helfer wurde vermittelt',
        content: 'Sie haben einen neuen Helfer vermittelt. Das Hilfegesuch wurde automatisch bestätigt, der Helfer erhält keine Nachricht zur Bestätigung'
    }
    toggleAltCanidateSelect = () => {
            this.setState({toggleAltCanidateSelect: true})
            

    }

    handleAltCanidateSelect = (id) => { 
        this.toggleAltCanidateDetails(id)
        
    }

    toggleAltCanidateDetails = async (id) => {
        const altCanidateDetails = await fetchUserProfile(id)
        this.setState({
            toggleAltCanidateDetails: true,
            altCanidateDetails: altCanidateDetails
        })
    }

    handleAltCanidateSelected = (altCanidate) => {
        const newCanidate = {}
  
        const eventId = this.props.event.event.id
        const messageId= this.props.event.messageId
        newCanidate.id= this.state.altCanidateDetails.id
        newCanidate.name = this.state.altCanidateDetails.name
        this.props.handleAlternativConfirmEvent(eventId, messageId, newCanidate)
       
       this.setState({
            notificationVisable: true,
            toggleAltCanidateSelect:false,
            toggleAltCanidateDetails: false,
            canidate: altCanidate, 
           // newCanidateMessage: newCanidateMessage
        })
       
       //setTimeout(()=>{ this.setState({notificationVisable: false}) }, 6000);
    }

    renderCanidate = (currentCanidate) => 
        <Grid container spacing={8} >
            <Grid item xs={12} >
                <RequesterDetails requester={this.props.requester}/>
            </Grid>
            <Grid item xs={12} >
                <CanidateDetails subheadline={this.state.newCanidateMessage} canidate={currentCanidate} type='connectedEvent' toggleView={this.porpstoggleView}/>
            </Grid>
        </Grid>

    renderAltCanidateSelect = () => {
        if(this.state.toggleAltCanidateSelect){
            return (
                <AltCanidateSelect 
                    canidatesOnWait={this.props.event.canidatesOnWait} 
                    connectedCanidate={this.props.canidate}
                    handleAltCanidateSelect={this.handleAltCanidateSelect}
                />)
          
        } else {
           return null
            
        }
    }

    render () {
        const { classes, handleConfirmEvent, event, toggleView, canidate } = this.props
        const { canidatesOnWait } = event
        const canidatesOnWaitCounter = Object.keys(canidatesOnWait).length
        var canidatesOnWaitButtonDisabled = false
        
        var currentCanidate = canidate
        
       
        if(this.state.canidate)
        currentCanidate = this.state.canidate

        if(canidatesOnWaitCounter <= 1){
            canidatesOnWaitButtonDisabled=true
        } else {
            canidatesOnWaitButtonDisabled=false
        }
        return (
            <Grid container {...defaultGridSettings.container} >
                <Grid item {...defaultGridSettings.item} >
                    <EventDetails event={event} type='connectedEvent' toggleView={toggleView}/>
                </Grid>
                <Grid item {...defaultGridSettings.item} >
                    {this.renderCanidate(currentCanidate)}
                </Grid>
                <Grid item {...defaultGridSettings.item} container spacing={8} >
                    <Grid item xs={12} >
                        {this.renderAltCanidateSelect()}
                    </Grid>
                    <Grid item xs={12} >
                        {this.state.toggleAltCanidateDetails 
                            ? <AltCanidateDetails canidate={this.state.altCanidateDetails} handleAltCanidateConnect={this.handleAltCanidateSelected}/>
                            : null}
                    </Grid>
                </Grid>
                <Grid item {...defaultGridSettings.item} >
                    <Button
                        onClick={()=>handleConfirmEvent(event.event.id, event.messageId)}
                        className={classes.confirmButton}
                        variant='contained'
                        color='primary'
                        size='small'
                        fullWidth
                    >
                        Hilfebedarf (für Helfer) bestätigen
                    </Button>
                    <Button
                        onClick={()=>this.toggleAltCanidateSelect()}
                        className={classes.selecteButton}
                        variant='contained'
                        color='primary'
                        disabled= {canidatesOnWaitButtonDisabled}
                        size='small'
                        fullWidth
                        >
                        {canidatesOnWaitButtonDisabled
                            ? 'Keine weiteren Hilfeangebote vorhanden'
                            : <Badge badgeContent={canidatesOnWaitCounter-1} color='secondary'>Weitere Helfer (Angebot) Anzeigen</Badge>
                        }
                    </Button>
                </Grid>
                {this.state.notificationVisable
                    ? <Notification notification={this.notification}/>
                    : null
                }
            </Grid>
        )
    }
}
const mapStateToProps = (state) => ({
    adminProfile: state.userState.profile
})

export default compose(
    withStyles(styles),
    connect(mapStateToProps),
)(AdminConnectedEventDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminConnectedEvents/AdminConnectedEventDetails.js